/**
 * Sport-aware column labels for tournament standings.
 *
 * Football's for/against/difference tallies are literal goals, so labels
 * read GF / GA / GD. Racquet sports don't have goals — the same tally
 * fields count GAMES won and lost, so the labels read PF / PA / PD
 * (Points/Games For/Against/Difference).
 *
 * The underlying `goals_for` / `goals_against` / `goal_difference` fields
 * on the backend `standings` docs are re-used unchanged so we do not
 * break any existing tournament or migration. Only the RENDERED LABELS
 * are localized per sport.
 */
const RACQUET_SPORTS = new Set(['padel', 'pickleball', 'tennis']);

/**
 * @param {string} sport
 * @returns {{ for: string, against: string, diff: string }}
 */
export const forAgainstLabels = (sport) =>
  RACQUET_SPORTS.has(String(sport || '').toLowerCase())
    ? { for: 'PF', against: 'PA', diff: 'PD' }
    : { for: 'GF', against: 'GA', diff: 'GD' };

export const isRacquetSport = (sport) =>
  RACQUET_SPORTS.has(String(sport || '').toLowerCase());
